export default {
  title: 'Pre-order',
  categories: {
    title: 'Most Popular',
  },
  header: {
    pickup: 'Pickup in 5 Minutes',
  },
};
